export const CREATE_SUBMITTAL = "api/submittal/"
export const UPDATE_SUBMITTAL = "api/submittal/id/{id}"
export const GET_SUBMITTAL_BY_ID = "api/submittal/id/{id}"
export const GET_SUBMITTALS_BY_PROJECT = "api/submittal/project_id/{projectId}"
export const GET_SUBMITTALS = "api/submittal/"
export const GET_SUBMITTALS_BY_USER = "api/submittal/name/{email}"
export const MARK_SUBMITTAL_AS_COMPLETED = "api/submittal/mark_as_closed/{id}"
export const DELETE_SUBMITTAL = "api/submittal/id/{id}"